var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative w-full",class:_vm.aspect_ratio_classes},[_c('div',{staticClass:"absolute inset-0 h-full bg-white bg-center bg-cover rounded bg-grey-lightest",style:({
            'background-image': ("url(" + _vm.src + ")")
        })})])}
var staticRenderFns = []

export { render, staticRenderFns }